import {
  FETCH_CITIES_BEGIN,
  FETCH_CITIES_SUCCESS,
  FETCH_CITIES_FAILURE
} from '../types';

const initialState = {
  cities: [],
  loading: false,
  error: null
};

export function cities(state = initialState, action) {
  switch (action.type) {
    case FETCH_CITIES_BEGIN:
      // Mark the state as "loading" so we can show a spinner or something
      // Also, reset any errors. We're starting fresh.
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_CITIES_SUCCESS:
      // All done: set loading "false".
      // Also, replace the cities with the ones from the server
      return {
        ...state,
        loading: false,
        cities: action.data
      };

    case FETCH_CITIES_FAILURE:
      // The request failed. It's done. So set loading to "false".
      // Save the error, so we can display it somewhere.
      // Since it failed, we don't have  cities to display anymore, so set `cities` empty.
      //
      // This is all up to you and your app though:
      // maybe you want to keep the  cities around!
      // Do whatever seems right for your use case.
      return {
        ...state,
        loading: false,
        error: action.error,
        cities: []
      };
    default:
      return state;
  }
}
